import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"

const useStyle = makeStyles((theme) => ({
  separator: {
    margin: theme.spacing(2)
  }
}))

export default function Separator(props) {
  const { className } = props
  const classes = useStyle()

  // merge props classes with default one
  let allClasses = classes.separator
  if (className) {
    allClasses += ` ${className}`
  }

  return <div className={allClasses} />
}

Separator.propTypes = {
  className: PropTypes.string
}

Separator.defaultProps = {
  className: undefined
}
